import React, { useState } from 'react';
import './Sidebar.css';
import {
  FaWhatsapp, FaHome, FaTruck, FaPlus, FaMoneyBillWave,
  FaListAlt, FaChartBar, FaSignOutAlt, FaChevronDown, FaChevronUp,
  FaBook, FaFileInvoice, FaUsers, FaBuilding, FaBell,
  FaCog, FaLifeRing, FaShieldAlt, FaFileAlt, FaCalendarAlt
} from 'react-icons/fa';
import { MdDashboard, MdReportGmailerrorred } from 'react-icons/md';
import { GiCommercialAirplane } from 'react-icons/gi';
import AppLogo from '../Logo.png';

const Sidebar = ({
  onMenuClick,
  onLogout,
  activePage,
  isOpen,
  setIsOpen
}) => {

  const [openDropdown, setOpenDropdown] = useState(null); // 'vehicles', 'bill', 'payment', 'reports'

  const toggleSidebar = () => setIsOpen(!isOpen);

  const handleMenuClick = (menuItem) => {
    if (menuItem === 'logout') {
      if (onLogout) onLogout();
      return;
    }
    if (onMenuClick) {
      onMenuClick(menuItem);
    }
    if (window.innerWidth <= 768) {
      setIsOpen(false);
    }
  };

  const handleDropdownToggle = (dropdownName) => {
    setOpenDropdown(openDropdown === dropdownName ? null : dropdownName);
  };

  return (
    <>
      <button className={`mobile-toggle ${isOpen ? 'active' : ''}`} onClick={toggleSidebar}>
        <span></span>
        <span></span>
        <span></span>
      </button>

      <div className={`sidebar-overlay ${isOpen ? 'active' : ''}`} onClick={toggleSidebar}></div>

      <div className={`sidebar ${isOpen ? 'open' : ''}`}>
        {/* Logo Section */}
        <div className="sidebar-logo">
          <img
            src={AppLogo}
            alt="DK RTO Advisor"
            className="app-logo"
          />
        </div>

        {/* Navigation */}
        <nav className="sidebar-nav">
          <NavItem
            icon={<FaHome />}
            label="Dashboard"
            active={activePage === 'dashboard'}
            onClick={() => handleMenuClick('dashboard')}
          />

          <NavItem
            icon={<FaBook />}
            label="Party Ledger"
            active={activePage === 'ledger-entry'}
            onClick={() => handleMenuClick('ledger-entry')}
          />

          <DropdownItem
            id="vehicles"
            icon={<FaTruck />}
            label="Vehicles"
            isOpen={openDropdown === 'vehicles'}
            onToggle={() => handleDropdownToggle('vehicles')}
          >
            <SubItem
              label="Add New Vehicle"
              active={activePage === 'new-entry'}
              onClick={() => handleMenuClick('new-entry')}
            />
            <SubItem
              label="Vehicle List"
              active={activePage === 'insurance-report'}
              onClick={() => handleMenuClick('insurance-report')}
            />
          </DropdownItem>

          <DropdownItem
            id="bill"
            icon={<FaFileInvoice />}
            label="Bill Management"
            isOpen={openDropdown === 'bill'}
            onToggle={() => handleDropdownToggle('bill')}
          >
            <SubItem
              label="Create Bill"
              active={activePage === 'payment-entry'}
              onClick={() => handleMenuClick('payment-entry')}
            />
            <SubItem
              label="Bill List"
              active={activePage === 'bill-report'}
              onClick={() => handleMenuClick('bill-report')}
            />
          </DropdownItem>

          <DropdownItem
            id="payment"
            icon={<FaMoneyBillWave />}
            label="Payment Management"
            isOpen={openDropdown === 'payment'}
            onToggle={() => handleDropdownToggle('payment')}
          >
            <SubItem
              label="Payment Entry"
              active={activePage === 'payment-in'}
              onClick={() => handleMenuClick('payment-in')}
            />
            <SubItem
              label="Payment List"
              active={activePage === 'payment-list'}
              onClick={() => handleMenuClick('payment-list')}
            />
          </DropdownItem>

          {/* <NavItem
            icon={<FaWhatsapp />}
            label="WhatsApp Message"
            active={activePage === 'whatsapp-msg'}
            onClick={() => handleMenuClick('whatsapp-msg')}
          /> */}

          <DropdownItem
            id="reports"
            icon={<MdReportGmailerrorred />}
            label="Reports"
            isOpen={openDropdown === 'reports'}
            onToggle={() => handleDropdownToggle('reports')}
          >
            <SubItem
              label="Party Report"
              active={activePage === 'party-report'}
              onClick={() => handleMenuClick('party-report')}
            />
            <SubItem
              label="Payment Report"
              active={activePage === 'payment-in-report'}
              onClick={() => handleMenuClick('payment-in-report')}
            />
            <SubItem
              label="Expiry Analysis"
              active={activePage === 'expiry-analysis'}
              onClick={() => handleMenuClick('expiry-analysis')}
            />
          </DropdownItem>

          <div className="nav-divider"></div>

          <NavItem
            icon={<FaSignOutAlt />}
            label="Logout"
            active={false}
            onClick={() => handleMenuClick('logout')}
            isLogout={true}
          />
        </nav>
      </div>

      <style jsx="true">{`
        .sidebar {
          width: 260px;
          height: 100vh;
          position: fixed;
          left: 0;
          top: 0;
          background: #ffffff;
          color: #1e293b;
          transition: all 0.3s ease;
          z-index: 1000;
          overflow-y: auto;
          box-shadow: 0 4px 25px rgba(0,0,0,0.08);
          border-right: 1px solid #e2e8f0;
        }

        .sidebar::-webkit-scrollbar {
          width: 4px;
        }

        .sidebar::-webkit-scrollbar-track {
          background: #1e293b;
        }

        .sidebar::-webkit-scrollbar-thumb {
          background: #475569;
          border-radius: 4px;
        }

        /* Mobile Toggle */
        .mobile-toggle {
          display: none;
          position: fixed;
          top: 16px;
          left: 16px;
          z-index: 1100;
          background: #1e293b;
          border: none;
          width: 40px;
          height: 40px;
          border-radius: 8px;
          cursor: pointer;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          gap: 5px;
          box-shadow: 0 2px 8px rgba(0,0,0,0.2);
        }

        .mobile-toggle span {
          width: 22px;
          height: 2px;
          background: white;
          transition: 0.3s;
        }

        .mobile-toggle.active span:nth-child(1) {
          transform: rotate(45deg) translate(5px, 5px);
        }

        .mobile-toggle.active span:nth-child(2) {
          opacity: 0;
        }

        .mobile-toggle.active span:nth-child(3) {
          transform: rotate(-45deg) translate(5px, -5px);
        }

        .sidebar-overlay {
          display: none;
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0,0,0,0.5);
          z-index: 999;
        }

        /* Logo Section */
        .sidebar-logo {
          padding: 12px 0;
          text-align: center;
          border-bottom: 1px solid #e2e8f0;
          margin-bottom: 20px;
          background: rgba(255,255,255,0.7);
          backdrop-filter: blur(10px);
        }

        .app-logo {
          width: 78px;
          height: 78px;
          object-fit: contain;
          transition: 0.4s ease;
        }

        .app-logo:hover {
          transform: scale(1.08) rotate(3deg);
        }

        .logo-text {
          font-size: 16px;
          font-weight: 700;
          color: white;
          letter-spacing: 1px;
          background: linear-gradient(135deg, #fff, #94a3b8);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        /* Navigation */
        .sidebar-nav {
          padding: 0 12px;
        }

        .nav-item {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 10px 14px;
          margin: 4px 0;
          border-radius: 10px;
          cursor: pointer;
          transition: all 0.2s ease;
          color: #94a3b8;
          font-size: 14px;
          font-weight: 500;
        }

        .nav-item:hover {
          background: linear-gradient(135deg, #dbeafe 0%, #eff6ff 100%);
          color: #2563eb;
          transform: translateX(4px);
        }

        .nav-item.active {
          background: linear-gradient(135deg, #2563eb 0%, #3b82f6 100%);
          color: white;
          box-shadow: 0 8px 20px rgba(37,99,235,0.25);
        }

        .nav-item.logout {
          margin-top: 8px;
          color: #ef4444;
        }

        .nav-item.logout:hover {
          background: rgba(239,68,68,0.1);
          color: #ef4444;
        }

        .nav-icon {
          width: 22px;
          font-size: 18px;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: 0.3s ease;
        }

        .nav-label {
          flex: 1;
        }

        .active-indicator {
          width: 3px;
          height: 20px;
          background: white;
          border-radius: 2px;
        }

        /* Dropdown */
        .dropdown-wrapper {
          margin: 4px 0;
        }

        .dropdown-toggle {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 11px 14px;
          border-radius: 14px;
          cursor: pointer;
          color: #475569;
          transition: all 0.3s ease;
        }

        .dropdown-toggle:hover {
          background: linear-gradient(135deg, #dbeafe 0%, #eff6ff 100%);
          color: #2563eb;
          transform: translateX(4px);
        }

        .dropdown-arrow {
          margin-left: auto;
          font-size: 10px;
          transition: transform 0.2s;
        }

        .dropdown-menu {
          margin-left: 28px;
          padding-left: 8px;
          border-left: 1px solid rgba(255,255,255,0.1);
        }

        .sub-item {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 9px 12px;
          margin: 4px 0;
          border-radius: 10px;
          cursor: pointer;
          font-size: 13px;
          color: #64748b;
          transition: all 0.3s ease;
        }

        .sub-item:hover {
          background: #eef4ff;
          color: #2563eb;
          padding-left: 18px;
        }

        .sub-item.active {
          background: linear-gradient(135deg, #bfdbfe 0%, #dbeafe 100%);
          color: #1d4ed8;
          font-weight: 600;
        }

        .sub-dot {
          width: 5px;
          height: 5px;
          background: #475569;
          border-radius: 50%;
          transition: all 0.2s;
        }

        .sub-item.active .sub-dot {
          background: #60a5fa;
          width: 8px;
          height: 8px;
        }

        .nav-divider {
          height: 1px;
          background: rgba(255,255,255,0.08);
          margin: 12px 0;
        }

        /* Responsive */
        @media (max-width: 768px) {
          .sidebar {
            transform: translateX(-100%);
            width: 260px;
          }

          .sidebar.open {
            transform: translateX(0);
          }

          .mobile-toggle {
            display: flex;
          }

          .sidebar-overlay.active {
            display: block;
          }
        }

        /* Hover Effects */
        @media (min-width: 769px) {
          .sidebar:hover .sidebar-logo {
            background: rgba(255,255,255,0.02);
          }
        }
        .nav-item:hover .nav-icon,
        .dropdown-toggle:hover .nav-icon {
          transform: scale(1.2) rotate(-8deg);
        }
      `}</style>
    </>
  );
};

// NavItem Component
const NavItem = ({ icon, label, active, onClick, isLogout }) => (
  <div className={`nav-item ${active ? 'active' : ''} ${isLogout ? 'logout' : ''}`} onClick={onClick}>
    <span className="nav-icon">{icon}</span>
    <span className="nav-label">{label}</span>
    {active && <span className="active-indicator"></span>}
  </div>
);

// DropdownItem Component
const DropdownItem = ({ icon, label, isOpen, onToggle, children }) => (
  <div className="dropdown-wrapper">
    <div className="dropdown-toggle" onClick={onToggle}>
      <span className="nav-icon">{icon}</span>
      <span className="nav-label">{label}</span>
      <span className="dropdown-arrow">
        {isOpen ? <FaChevronUp size={10} /> : <FaChevronDown size={10} />}
      </span>
    </div>
    {isOpen && <div className="dropdown-menu">{children}</div>}
  </div>
);

// SubItem Component
const SubItem = ({ label, active, onClick }) => (
  <div className={`sub-item ${active ? 'active' : ''}`} onClick={onClick}>
    <span className="sub-dot"></span>
    <span className="sub-label">{label}</span>
  </div>
);

export default Sidebar;